import React, { useCallback, useEffect } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import Dialog from 'components/Dialog'
import { useBreakpoint } from 'utils/Hooks'
import { RootState, RootActionType } from 'duck'
import { dialogActions, dialogSelectors, DialogNames } from 'duck/DialogDuck'
import Typography from 'components/Typography'
import { apiSelectors } from 'duck/ApiDuck'
import { appActions, appSelectors } from 'duck/AppDuck'
import ButtonConnectMetamask from 'components/Button/ButtonConnectMetamask'
import stylesGlobal from 'stylesGlobal.module.scss'
import styles from './Dialogs.module.scss'

const CLASSES_DIALOG = {
  paper: styles.DialogPaper
}

const mapStateToProps = (state: RootState) => ({
  dialogDatum: dialogSelectors.dialogDatum[DialogNames.CONNECT_TO_METAMASK](state),
  currentUserAddress: apiSelectors.currentUserAddress(state),
  retrieveConfigLoading: apiSelectors.loading['mineProject.retrieveConfig'](state),
  activeDialog: dialogSelectors.activeDialog(state),
  connectLoading: appSelectors.connectLoading(state)
})

const mapDispatchToProps = (dispatch: Dispatch<RootActionType>) =>
  bindActionCreators(
    {
      closeDialog: dialogActions.closeDialog,
      connect: appActions.metamask.connect
    },
    dispatch
  )

type DialogMetamaskConnectionProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const DialogMetamaskConnection: React.FC<DialogMetamaskConnectionProps> = props => {
  const {
    closeDialog,
    connect,
    connectLoading,
    retrieveConfigLoading,
    activeDialog,
    dialogDatum,
    currentUserAddress
  } = props

  const connecting = Boolean(connectLoading || retrieveConfigLoading)
  const open = activeDialog === DialogNames.CONNECT_TO_METAMASK
  const actionText = dialogDatum?.actionText
  const { isSmallscreenAbove } = useBreakpoint()

  const handleCloseDialog = useCallback(() => {
    closeDialog()
  }, [closeDialog])

  useEffect(() => {
    if (currentUserAddress) {
      closeDialog()
    }
  }, [closeDialog, currentUserAddress])

  return (
    <Dialog
      maxWidth={false}
      open={open}
      onClose={handleCloseDialog}
      onBackdropClick={handleCloseDialog}
      classes={isSmallscreenAbove ? CLASSES_DIALOG : undefined}
      fullScreen={!isSmallscreenAbove}
      fullWidth
    >
      <div className={clsx(stylesGlobal.MarginTop4, styles.DialogContentWrapper)}>
        <div className={clsx(stylesGlobal.TextCenter)}>
          <Typography
            variant="h5"
            component="h2"
            fontWeight="bold"
            className={stylesGlobal.MarginBottom16}
          >
            Connect To Metamask
          </Typography>

          <Typography variant="body1">
            {`You need to connect to metamask to ${actionText || 'do this action'}.`}
          </Typography>
        </div>

        <div className={clsx(stylesGlobal.MarginTop16, stylesGlobal.TextCenter)}>
          <ButtonConnectMetamask
            className={stylesGlobal.MarginTop24}
            loading={connecting}
            onClick={() => {
              connect({ connectLocation: 'Dialog' })
            }}
          />
        </div>
      </div>
    </Dialog>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogMetamaskConnection)
